<template>
  <!-- Loading 状态 -->
  <div v-if="isLoading" class="loading">
    <img
      src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260303/flower&14392&20260303173227.png"
    />
  </div>
  <div class="detail-container" v-else>
    <!-- 视频背景 -->
    <div class="video-bg">
      <video autoplay loop muted playsinline class="bg-video">
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </div>

    <!-- 顶部logo -->
    <div class="top-logo">
      <img
        src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260302/ydLogo2&4071&20260302113359.png"
        alt="易点生活"
      />
    </div>

    <!-- 祝福文案 -->
    <div class="blessing-text animated">
      <img :src="blessingText" alt="女神节快乐" />
    </div>

    <!-- 领取按钮 -->
    <!-- 权益状态 0：待领取 1：已领取 2：领取失败 3：领取中 -->
    <div class="receive-btn animated">
      <van-button
        type="primary"
        size="large"
        :loading="btnLoading"
        loading-text="领取中..."
        :disabled="detailData.orderStatus !== 0"
        color="#000000"
        @click="handleReceive"
      >
        {{ detailData.orderStatus === 0 ? '领取专属福利' : '已领取专属福利' }}
      </van-button>
    </div>

    <!-- 成功弹框 -->
    <van-dialog
      v-model="showSuccessDialog"
      :showConfirmButton="false"
      class="custom-dialog"
    >
      <div class="dialog-content">
        <div class="dialog-title">您将获得：</div>
        <div class="success-text">
          <p>女神节专属</p>
          <p>神秘祝福礼物</p>
        </div>
        <div class="dialog-rule">请注意查收短信！</div>
        <van-button
          type="primary"
          color="#000000"
          class="dialog-btn"
          @click=";(detailData.orderStatus = 1), (showSuccessDialog = false)"
        >
          开心收下
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { girlReceiveOrder, girlReceive } from '@/api/ydGirlsDay'

export default {
  data() {
    return {
      videoUrl: '',
      blessingText: '',
      detailData: {},
      btnLoading: false,
      showSuccessDialog: false,
      isLoading: true,
      showContent: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true
        const { data } = await girlReceiveOrder()
        this.isLoading = false
        this.videoUrl = data.actPic
        this.blessingText = data.actText
        this.detailData = data
      } catch (error) {
        this.isLoading = false
        sessionStorage.removeItem('ydGrilsDayToken')
        console.error('获取页面数据失败:', error)
        // this.$toast.fail('获取页面数据失败')
      }
    },
    async handleReceive() {
      try {
        this.btnLoading = true
        await girlReceive()
        this.btnLoading = false
        this.showSuccessDialog = true
      } catch (error) {
        console.error('领取失败:', error)
        this.btnLoading = false
        // this.$toast.fail('领取失败，请重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.detail-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #000;
  img {
    width: 80px;
    display: block;
    margin: auto;
  }
}

.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  .bg-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.top-logo {
  position: absolute;
  top: 1.8%;
  left: 15px;
  z-index: 10;
  img {
    width: 103px;
    height: auto;
  }
}

.blessing-text {
  position: absolute;
  z-index: 5;
  width: 90%;
  left: 5%;
  bottom: 16.7%;
  opacity: 0;
  transform: translateY(20px);
  &.animated {
    animation: fadeInUp 0.8s ease-out forwards;
    animation-delay: 2s;
  }
  img {
    width: 100%;
  }
}

.receive-btn {
  position: absolute;
  left: 21%;
  bottom: 8%;
  width: 58%;
  height: 50px;
  border-radius: 25px;
  font-size: 18px;
  font-weight: bold;
  z-index: 10;
  opacity: 0;
  transform: translateY(20px);
  &.animated {
    animation: fadeInUp 0.8s ease-out forwards;
    animation-delay: 2s;
  }
  .van-button {
    border-radius: 25px;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-dialog {
  width: 96%;
  max-width: 340px;
  height: auto;
  aspect-ratio: 743 / 692;
  background: url('https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260302/girlModal&139278&20260302111427.png');
  background-size: contain;
  text-align: center;
  .dialog-content {
    .dialog-title {
      font-size: 18px;
      font-weight: bold;
      color: #000;
      margin: 50px 0 13px;
    }
    @media screen and (max-width: 320px) {
      .dialog-title {
        margin: 38px 0 10px;
      }
    }
    .success-text {
      font-size: 22px;
      color: #3e3752;
      margin-bottom: 13px;
      font-weight: bold;
    }
    .dialog-rule {
      font-size: 14px;
      color: #999;
      margin-bottom: 24px;
    }
    .dialog-btn {
      width: 180px;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
